import { ShareSandboxProvider } from "./ShareSandboxProvider";
import { ShareSandboxUI } from "./ShareSandboxUI";

export const ShareSandbox: React.FC<{
  editorURL: URL;
  sandboxId: string;
}> = ({ sandboxId, editorURL }) => {
  return (
    <ShareSandboxProvider injectedAPI={{}} sandboxId={sandboxId}>
      <ShareSandboxUI editorURL={editorURL} />
    </ShareSandboxProvider>
  );
};
